import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useReducer } from 'react';
import { retrainingInitState } from '../initState';
import retrainingReducer from '../reducers/retraining';
import retrainingActions from '../actions/retraining';
import { wrapActions } from '../lib';
const RetrainingContext = createContext({});
RetrainingContext.displayName = 'RetrainingContext';
const RetrainingContextActions = createContext({});
RetrainingContextActions.displayName = 'RetrainingContextActions';
const RetrainingContextProvider = ({
  value,
  children
}) => {
  const [state, dispatch] = useReducer(retrainingReducer, Object.assign(Object.assign({}, retrainingInitState), value));
  const actions = useMemo(() => wrapActions({
    dispatch,
    actions: retrainingActions
  }), [dispatch]);
  return _jsx(RetrainingContext.Provider, {
    value: {
      state
    },
    children: _jsx(RetrainingContextActions.Provider, {
      value: {
        actions
      },
      children: children
    })
  });
};
const useRetraining = () => {
  const context = useContext(RetrainingContext);
  if (!(context === null || context === void 0 ? void 0 : context.state)) {
    throw new Error('useRetraining must be used within a Provider');
  }
  return context.state;
};
const useRetrainingActions = () => {
  const context = useContext(RetrainingContextActions);
  if (!(context === null || context === void 0 ? void 0 : context.actions)) {
    throw new Error('useRetrainingActions must be used within a Provider');
  }
  return context.actions;
};
export { RetrainingContextProvider, useRetraining, useRetrainingActions };